<template>
  <base-modal
    :title="modalTitle"
    :hide-footer="true"
    class="mark-relation-modal"
    head-img-url=""
    @close="handleClose">
    <template #title>
      {{isEditMode ? '交叉批改规则配置' : '查看配置结果'}}
    </template>
    <template #content>
      <div class="mark-rule-detail-modal">
        <!-- 考试信息 -->
        <div class="exam-info-section">
          <div class="info-content">
            <div class="info-item">
              <span class="info-label">考试名称:</span>
              <span class="info-value">{{ examInfo.roundName || '-' }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">考试时间:</span>
              <span class="info-value">{{ examTimeText }}</span>
            </div>
            <div class="info-item progress-item">
              <span class="info-label">考试当前进度:</span>
              <span class="progress-status" :class="examInfo.progressStatus?.class">
                <i class="status-dot"></i>
                {{ examInfo.progressStatus?.text }}
              </span>
            </div>
          </div>
        </div>
        <!-- 学校对应关系 -->
        <div class="school-relation-section">
          <div class="relation-title">
            <div class="title-item">考生学校</div>
            <div class="title-item">批改学校</div>
          </div>
          <div class="relation-item-warp">
            <div class="relation-item" v-for="(relation, index) in roundMark?.relations" :key="index">
              <div class="exam-school school-item">{{relation.schoolName}}</div>
              <div class="line"></div>
              <el-select class="check-school school-item"
                         v-model="relation.markSchoolId"
                         placeholder="请选择"
                         :disabled="!isEditMode" @change="e => handleSchoolChange(e,relation)">
                <el-option :label="school.schoolName" :value="school.id"
                           v-for="(school) in schoolList.filter(i => i.id !== 0)"
                           :key="school.id"></el-option>
              </el-select>
            </div>
          </div>
        </div>

        <!-- 操作按钮 -->
        <div class="action-buttons" v-if="isEditMode">
          <el-button 
            @click="handleCancel" 
            class="cancel-btn">
            取消
          </el-button>
          <el-popover placement="top"
                      popper-class="mark-popover"
                      v-model="popVisible">
            <p class="pop-title">请确认是否提交？</p>
            <p class="pop-content">请仔细确认批改规则，规则确认后，立即生效，不可修改</p>
            <div  class="pop-btns">
              <el-button size="mini" type="text" @click="popVisible = false">取消</el-button>
              <el-button type="primary" size="mini" @click="handleSave">确定</el-button>
            </div>
            <el-button
                slot="reference"
                type="primary"
                class="confirm-btn">
              确认
            </el-button>
          </el-popover>
        </div>
      </div>
    </template>
  </base-modal>
</template>

<script>
import BaseModal from '@/components/baseModal.vue';
import { Select, Option, Button,Popover } from 'element-ui';
import {publishMarkRelation, saveMarkRelation} from "@/api/qzTeacher";
import {getSystemTimeSync} from '@/api/api';
import dayjs from 'dayjs';

export default {
  name: 'MarkRuleDetailModal',
  components: {
    BaseModal,
    'el-select': Select,
    'el-option': Option,
    'el-button': Button,
    'el-popover': Popover
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    level:{
      type:String,
      default:''
    },
    examInfo: {
      type: Object,
      default: () => ({})
    },
    roundMark:{
      type: Object,
      default: () => ({})
    },
    schoolList: {
      type: Array,
      default: () => []
    },
    isEditMode: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    modalTitle() {
      return '交叉批改规则配置';
    },
    examTimeText() {
      if (!this.examInfo.startTime) {
        return '-';
      }
      return  dayjs(this.examInfo.startTime).format('YYYY.M.DD HH:mm');
    }
  },
  data() {
    return {
      popVisible:false
    }
  },
  methods: {
    handleClose() {
      this.$emit('close');
    },
    // 确认交叉批改规则
    handleSave() {
      publishMarkRelation({
        id:this.roundMark.id,
        level:this.level,
      }).then(res => {
        if(res.code === 200 && res.body.result){
          this.$emit('save');
        }
      })
    },
    handleCancel() {
      // 恢复原始数据
      this.$emit('cancel');
    },
    handleSchoolChange(e,relation) {
      // 更新批改学校
      const {roundMarkId,courseExamId,roundId,schoolId,id} = relation || {};
      const params = {
        id,
        level:this.level,
        roundMarkId,
        courseExamId,
        roundId,
        schoolId,
        markSchoolId: e,
      }
      saveMarkRelation(params).then(res => {
        if(res.code === 200 && res.body.result){
          this.$message.success('批改学校更新成功');
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.mark-relation-modal /deep/ .base-modal_title {
  display: flex;
  align-items: center;
  font-size: 24px;
  font-weight: 600;
  margin-top: 0;
  color: #000000E5;
  margin-bottom: 24px;
  width: 100%;
}
.mark-relation-modal /deep/ .base-modal_cnt{
  padding: 30px 48px 36px;
}
.mark-rule-detail-modal {
  width: 100%;
  max-width: 800px;
  .section-title {
    font-size: 16px;
    font-weight: 600;
    color: #1D2129;
    margin-bottom: 16px;
    padding-bottom: 8px;
    border-bottom: 2px solid #E5E6EB;
  }
  
  .exam-info-section {
    margin-bottom: 24px;
    
    .info-content {
      .info-item {
        display: flex;
        align-items: center;
        margin-bottom: 12px;
        
        .info-label {
          font-size: 16px;
          color: #000000;
          margin-right: 24px;
        }
        
        .info-value {
          font-size: 16px;
          color: #1D2129;
          font-weight: 400;
        }
        
        &.progress-item {
          .progress-status {
            display: flex;
            align-items: center;
            font-size: 14px;
            font-weight: 500;
            
            .status-dot {
              width: 8px;
              height: 8px;
              border-radius: 50%;
              margin-right: 8px;
              display: inline-block;
            }
            
            &.not-started {
              color: #F53F3F;
              .status-dot {
                background: #F53F3F;
              }
            }
            
            &.in-progress {
              color: #00B42A;
              .status-dot {
                background: #00B42A;
              }
            }
            
            &.ended {
              color: #86909C;
              .status-dot {
                background: #86909C;
              }
            }
          }
        }
      }
    }
  }
  
  .rule-section {
    margin-bottom: 24px;
    
    .rule-content {
      .rule-item {
        display: flex;
        align-items: center;
        margin-bottom: 12px;
        
        .rule-label {
          font-size: 14px;
          color: #4E5969;
          margin-right: 8px;
          min-width: 100px;
        }
        
        .rule-value {
          font-size: 14px;
          color: #1D2129;
          font-weight: 500;
        }
      }
    }
  }
  
  .school-relation-section {
    margin-bottom: 32px;
    background: #F5F6F9;
    border-radius: 12px;
    padding: 20px 32px 28px;
    .relation-title{
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 16px;
      .title-item{
        width: 220px;
        text-align: center;
        color: #000000;
        font-size: 16px;
        font-weight: 500;
      }
    }
    .relation-item-warp{
      max-height: 350px;
      overflow-y: scroll;
      overflow-x: hidden;
      .relation-item{
        margin-bottom: 16px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .school-item{
          height: 40px;
          border-radius: 4px;
          line-height: 40px;
          box-sizing: border-box;
          color: #1D2129;
          font-size: 14px;
          &.exam-school{
            width: 220px;
            background: #E5E6EB;
            padding: 0 12px;
            text-align: left;
            white-space: nowrap;
          }
          &.check-school {
            .el-select{

            }
          }
        }
        .line{
          width: 40px;
          height: 1px;
          background: #C9CDD4;
        }
      }
    }
  }
  
  .action-buttons {
    display: flex;
    justify-content: center;
    gap: 16px;
    margin-top: 24px;
    
    .el-button {
      min-width: 100px;
      height: 36px;
      border-radius: 18px;
      font-size: 14px;
      font-weight: 500;
      
      &.cancel-btn {
        background: #FFFFFF;
        border: 1px solid #D9D9D9;
        color: #666666;
        
        &:hover {
          background: #F5F5F5;
          border-color: #BFBFBF;
        }
      }
      
      &.confirm-btn {
        background: #E60012;
        border-color: #E60012;
        color: #fff;
        
        &:hover {
          background: #CC0010;
          border-color: #CC0010;
        }
      }
    }
  }
}
</style>
<style>
.mark-popover{
  padding: 30px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  .pop-title{
    margin-bottom: 24px;
    font-size: 18px;
    font-weight: 600;
    color: #1D2129;
  }
  .pop-content{
    color: #4E5969;
    font-size: 14px;
    font-weight: 400;
    max-width: 250px;
    text-align: center;
  }
  .pop-btns{
    margin-top: 30px;
    button{
      width: 80px;
      height: 36px;
      border-radius: 90px;
      font-size: 14px;
      border: none;
      &:first-child{
        color: #1D2129;
        background: #F2F3F5;
      }
      &:last-child{
        background: #E60012;
        color: #FFFFFF;
      }
    }
  }
}
.mark-relation-modal{
  .el-input__inner{
    width: 220px !important;
  }
  .el-input.is-disabled .el-input__inner{
    color: #484B53;
  }
}
</style>
